<template>
    <TransitionGroup tag="div" name="snackbar" class="snackbars-container">
        <Snackbar v-for="snackbar in snackbars" :key="snackbar.message" v-bind="snackbar" />
    </TransitionGroup>
</template>

<script lang="ts" setup>
import Snackbar from "@/shared/components/atoms/Snackbar.vue";
import useSazkaSnackbar from "@/shared/composables/use-sazka-snackbar";

const { snackbars } = useSazkaSnackbar();
</script>
